import { inject, Injectable } from "@angular/core";

import { CURRENCY_MAP, CurrencyConfiguration, LOCALE } from "@hermes/core-app-core";
import { LocaleCode } from "@hermes/locale";

@Injectable()
export class CurrencyService {
    private locale = inject(LOCALE);

    /**
     * Get local and currency code from context
     *
     *
     * @returns angular format locale, ISO_4217 currency code, symbol and format
     * (example : ['fr', 'EUR', '€', 'full'])
     */
    public getCurrencyConfiguration(
        preferredCurrencyCode?: string,
        storeLocale?: LocaleCode,
    ): CurrencyConfiguration {
        const localeConfig = storeLocale
            ? CURRENCY_MAP[storeLocale]
            : CURRENCY_MAP[this.locale.code];

        if (
            localeConfig.code === preferredCurrencyCode ||
            preferredCurrencyCode === undefined
        ) {
            return localeConfig;
        }

        return (
            Object.values(CURRENCY_MAP).find(
                (config) => config.code === preferredCurrencyCode,
            ) ?? localeConfig
        );
    }

    public getLocaleDefaultCurrency() {
        const currencyConfiguration = CURRENCY_MAP[this.locale.code];
        if (!currencyConfiguration) {
            throw new Error("Missing locale default currency");
        }
        return currencyConfiguration.code;
    }
}
